import React from 'react'
import NavigationBar from './NavigationBar'
import aboutImg from '../assets/about.jpg'
import { Col, Container, Row } from 'react-bootstrap'
import Footer from './Footer'


export default function Home() {
    return (
        <div>
            <NavigationBar />
            <Container style={{ marginTop: "3rem", width: "100%" }}>
                <Row>
                    <Col md="12" lg="6">
                        <img src={aboutImg} style={{ width: "100%" }} />
                    </Col>
                    <Col md="12" lg="6">
                        <h3>
                            Why choose our company?
                        </h3>
                        <p>
                            We use Diaba 's best practices
                            to build a modern, fast and reliable marketplace, tailored to our local market.By optimizing the efficiency of the digital trade chain, Diaba Market Place enables millions of businesses to grow faster and reach previously inaccessible markets.
                        </p>
                        {/* <h3>
                            Our Mission
                        </h3> */}
                        <p>
                            We have created a smart ecosystem to unlock the full potential of digital commerce, integrating all aspects: technology, logistics, finance and user experience.
                        </p>
                        {/* <h3>
                            Our Vision
                        </h3> */}
                        <p>
                            Our services are designed by innovation leaders, deliver strategic value to businesses, and integrate seamlessly into every stage of the business chain.
                        </p>
                        <p>
                            This approach to online commerce tackles traditional market barriers and views the digital economy as an integrated ecosystem.
                        </p>
                    </Col>
                </Row>

            </Container>
            <Footer />
        </div>
    )
}
